<template>
  <l-dot-pulse size="43" speed="1.3" color="#42b983"></l-dot-pulse>
</template>
